export default __webpack_public_path__ + "static/luxury-48e9c20ff7c4a098327e2fccccd800bf.jpg";